import {
  Box,
  ListItemButton,
  ListItemButtonProps,
  Typography,
  styled,
} from '@mui/material';
import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { KundenDokument } from '@codefluegel/wowis-rest-typescript-client';
import moment from 'moment';
import useMedia from '../../hooks/useMedia';

const DocumentItem = styled(ListItemButton)<ListItemButtonProps>(
  ({ theme }) => ({
    '&:hover .MuiTypography-root': {
      color: theme.palette.background.paper,
    },
  }),
);

interface Props {
  document: KundenDokument;
  onDocumentClick?: () => void;
  textColor?: string;
  bgHoverColor?: string;
  documentGroupName?: string;
}

const DocumentListItem: FC<Props> = observer(props => {
  const {
    document,
    onDocumentClick,
    textColor,
    bgHoverColor,
    documentGroupName,
  } = props;
  const isMobile = useMedia('md');

  const date = moment(document.datum || '').format('DD.MM.YYYY');

  return (
    <DocumentItem
      key={document.name}
      onClick={onDocumentClick}
      sx={{
        borderBottom: `1px solid ${textColor || ''}`,
        '&:hover': {
          color: textColor,
          // backgroundColor: 'darkred',
          backgroundColor: bgHoverColor,
        },
      }}
    >
      <Box
        width={1}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            width: 'auto',
            textTransform: 'capitalize',
          }}
          color={textColor}
        >
          {document.name ?? ''}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: isMobile ? 'center' : 'space-between',
            alignItems: 'flex-end',
          }}
        >
          {documentGroupName && (
            <Typography
              variant="body2"
              sx={{
                marginLeft: 2,
                width: isMobile ? 110 : 'auto',
                whiteSpace: isMobile ? 'normal' : 'nowrap',
              }}
              color={textColor}
              fontWeight="fontWeightBold"
              textAlign="right"
            >
              {documentGroupName}
            </Typography>
          )}
          <Typography
            variant="body2"
            textAlign="right"
            sx={{ width: 100 }}
            color={textColor}
          >
            {date}
          </Typography>
        </Box>
      </Box>
    </DocumentItem>
  );
});

export default DocumentListItem;
